import React, { useState, useEffect } from 'react';
import { Button, Container, Row, Col, Input, Label } from 'reactstrap';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import api from '../services/api';

const CustomTimePicker = ({ selectedStart, selectedEnd, bookingDate, onTimeSelected }) => {
    const [times, setTimes] = useState([]);
    const [startTime, setStartTime] = useState(selectedStart || '');
    const [endTime, setEndTime] = useState(selectedEnd || '');

    // Fetch times when bookingDate changes
    useEffect(() => {
        api.get(`/business-hours/?date=${moment(bookingDate).format('YYYY-MM-DD')}`)
            .then(res => {
                const timeSlots = [];
                let current = moment(bookingDate)
                    .startOf('day')
                    .add(moment.duration(res.data.start_time));
                let end = moment(bookingDate)
                    .startOf('day')
                    .add(moment.duration(res.data.end_time));

                while (current.isSameOrBefore(end)) {
                    timeSlots.push(current.format());
                    current.add(15, 'minutes');
                }

                setTimes(timeSlots);
            })
            .catch(err => console.log(err));
    }, [bookingDate]);

    // Sync state when selectedStart or selectedEnd changes in parent
    useEffect(() => {
        setStartTime(selectedStart || '');
        setEndTime(selectedEnd || '');
    }, [selectedStart, selectedEnd]);

    const handleSelectTime = () => {
        if (startTime && endTime) {
            const start = moment(startTime);
            const end = moment(endTime);
            const duration = Math.abs(moment.duration(end.diff(start)).asMinutes());
            onTimeSelected(startTime, endTime, duration);
        }
    };

    // Only show end times after the selected start time
    const filteredEndTimes = startTime
        ? times.filter(time => moment(time).isAfter(moment(startTime)))
        : times;

    return (
        <Container>
            <Row className="mb-3">
                <Col>
                    <Label for="startTimeSelect"><strong>Start Time</strong></Label>
                    <Input
                        id="startTimeSelect"
                        type="select"
                        value={startTime}
                        onChange={(e) => {
                            setStartTime(e.target.value);
                            setEndTime('');
                        }}
                    >
                        <option value="">Select Start Time</option>
                        {times.map(time => (
                            <option key={time} value={time}>
                                {moment(time).format('h:mm A')}
                            </option>
                        ))}
                    </Input>
                </Col>
                <Col>
                    <Label for="endTimeSelect"><strong>End Time</strong></Label>
                    <Input
                        id="endTimeSelect"
                        type="select"
                        value={endTime}
                        disabled={!startTime}
                        onChange={(e) => setEndTime(e.target.value)}
                    >
                        <option value="">Select End Time</option>
                        {filteredEndTimes.map(time => (
                            <option key={time} value={time}>
                                {moment(time).format('h:mm A')}
                            </option>
                        ))}
                    </Input>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Button
                        color="primary"
                        block
                        disabled={!startTime || !endTime}
                        onClick={handleSelectTime}
                    >
                        Select Time
                    </Button>
                </Col>
            </Row>
        </Container>
    );
};

export default CustomTimePicker;
